import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { uniqueArray } from "~/utils";

const ColorsPicker = ({ colors, onChange, value }) => {
  const [activeColor, setActiveColor] = useState(null);

  useEffect(() => {
    if (value) {
      setActiveColor(value);
    }
  }, [value]);

  return (
    <div className="d-flex flex-wrap">
      {uniqueArray(colors)?.map((color, idx) => (
        <div
          className="mr-2 mb-2"
          key={`${color}-${idx}`}
          onClick={() => {
            setActiveColor(color);
            onChange(color);
          }}
          style={{
            width: 30,
            height: 30,
            borderRadius: "100%",
            backgroundColor: color,
            border: activeColor === color ? "3px solid red" : "2px solid black",
          }}
        />
      ))}
    </div>
  );
};

ColorsPicker.defaultProps = {
  value: null,
};

ColorsPicker.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default ColorsPicker;
